"use strict";

require("core-js/modules/es6.array.filter.js");
var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es7.array.includes.js");
require("core-js/modules/es6.string.small.js");
require("core-js/modules/es6.regexp.replace.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _image = _interopRequireDefault(require("@gravity/image"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _product = require("@nucleo/product");
var _ProductHelper = _interopRequireDefault(require("./ProductHelper"));
var _jsxFileName = "/codebuild/output/src3559094960/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductImage.js",
  _templateObject,
  _templateObject2;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_2i4ocq7usk() {
  var path = "/codebuild/output/src3559094960/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductImage.js";
  var hash = "a497a2689429322935202704eeab8f04d666610c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3559094960/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductImage.js",
    statementMap: {
      "0": {
        start: {
          line: 26,
          column: 22
        },
        end: {
          line: 32,
          column: 1
        }
      },
      "1": {
        start: {
          line: 34,
          column: 16
        },
        end: {
          line: 87,
          column: 1
        }
      },
      "2": {
        start: {
          line: 36,
          column: 24
        },
        end: {
          line: 36,
          column: 78
        }
      },
      "3": {
        start: {
          line: 89,
          column: 23
        },
        end: {
          line: 89,
          column: 25
        }
      },
      "4": {
        start: {
          line: 91,
          column: 29
        },
        end: {
          line: 106,
          column: 1
        }
      },
      "5": {
        start: {
          line: 92,
          column: 2
        },
        end: {
          line: 92,
          column: 44
        }
      },
      "6": {
        start: {
          line: 94,
          column: 2
        },
        end: {
          line: 105,
          column: 3
        }
      },
      "7": {
        start: {
          line: 95,
          column: 22
        },
        end: {
          line: 102,
          column: 84
        }
      },
      "8": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 104,
          column: 70
        }
      },
      "9": {
        start: {
          line: 108,
          column: 31
        },
        end: {
          line: 124,
          column: 1
        }
      },
      "10": {
        start: {
          line: 109,
          column: 2
        },
        end: {
          line: 109,
          column: 44
        }
      },
      "11": {
        start: {
          line: 110,
          column: 2
        },
        end: {
          line: 123,
          column: 3
        }
      },
      "12": {
        start: {
          line: 111,
          column: 22
        },
        end: {
          line: 120,
          column: 92
        }
      },
      "13": {
        start: {
          line: 115,
          column: 34
        },
        end: {
          line: 117,
          column: 13
        }
      },
      "14": {
        start: {
          line: 122,
          column: 4
        },
        end: {
          line: 122,
          column: 70
        }
      },
      "15": {
        start: {
          line: 139,
          column: 16
        },
        end: {
          line: 139,
          column: 80
        }
      },
      "16": {
        start: {
          line: 140,
          column: 22
        },
        end: {
          line: 140,
          column: 43
        }
      },
      "17": {
        start: {
          line: 142,
          column: 4
        },
        end: {
          line: 142,
          column: 93
        }
      },
      "18": {
        start: {
          line: 144,
          column: 26
        },
        end: {
          line: 162,
          column: 3
        }
      },
      "19": {
        start: {
          line: 145,
          column: 4
        },
        end: {
          line: 161,
          column: 5
        }
      },
      "20": {
        start: {
          line: 146,
          column: 31
        },
        end: {
          line: 146,
          column: 67
        }
      },
      "21": {
        start: {
          line: 147,
          column: 33
        },
        end: {
          line: 147,
          column: 71
        }
      },
      "22": {
        start: {
          line: 148,
          column: 6
        },
        end: {
          line: 155,
          column: 7
        }
      },
      "23": {
        start: {
          line: 149,
          column: 8
        },
        end: {
          line: 149,
          column: 46
        }
      },
      "24": {
        start: {
          line: 150,
          column: 8
        },
        end: {
          line: 154,
          column: 10
        }
      },
      "25": {
        start: {
          line: 156,
          column: 6
        },
        end: {
          line: 160,
          column: 8
        }
      },
      "26": {
        start: {
          line: 164,
          column: 2
        },
        end: {
          line: 177,
          column: 4
        }
      },
      "27": {
        start: {
          line: 180,
          column: 0
        },
        end: {
          line: 200,
          column: 2
        }
      },
      "28": {
        start: {
          line: 202,
          column: 0
        },
        end: {
          line: 216,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 36,
            column: 15
          },
          end: {
            line: 36,
            column: 16
          }
        },
        loc: {
          start: {
            line: 36,
            column: 24
          },
          end: {
            line: 36,
            column: 78
          }
        },
        line: 36
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 91,
            column: 29
          },
          end: {
            line: 91,
            column: 30
          }
        },
        loc: {
          start: {
            line: 91,
            column: 53
          },
          end: {
            line: 106,
            column: 1
          }
        },
        line: 91
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 108,
            column: 31
          },
          end: {
            line: 108,
            column: 32
          }
        },
        loc: {
          start: {
            line: 108,
            column: 55
          },
          end: {
            line: 124,
            column: 1
          }
        },
        line: 108
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 115,
            column: 28
          },
          end: {
            line: 115,
            column: 29
          }
        },
        loc: {
          start: {
            line: 115,
            column: 34
          },
          end: {
            line: 117,
            column: 13
          }
        },
        line: 115
      },
      "4": {
        name: "ProductImage",
        decl: {
          start: {
            line: 129,
            column: 9
          },
          end: {
            line: 129,
            column: 21
          }
        },
        loc: {
          start: {
            line: 138,
            column: 3
          },
          end: {
            line: 178,
            column: 1
          }
        },
        line: 138
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 144,
            column: 26
          },
          end: {
            line: 144,
            column: 27
          }
        },
        loc: {
          start: {
            line: 144,
            column: 49
          },
          end: {
            line: 162,
            column: 3
          }
        },
        line: 144
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 92,
            column: 21
          },
          end: {
            line: 92,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 92,
            column: 21
          },
          end: {
            line: 92,
            column: 37
          }
        }, {
          start: {
            line: 92,
            column: 41
          },
          end: {
            line: 92,
            column: 43
          }
        }],
        line: 92
      },
      "1": {
        loc: {
          start: {
            line: 94,
            column: 2
          },
          end: {
            line: 105,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 2
          },
          end: {
            line: 105,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 94
      },
      "2": {
        loc: {
          start: {
            line: 95,
            column: 22
          },
          end: {
            line: 102,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 96,
            column: 8
          },
          end: {
            line: 101,
            column: 9
          }
        }, {
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 102,
            column: 84
          }
        }],
        line: 95
      },
      "3": {
        loc: {
          start: {
            line: 109,
            column: 21
          },
          end: {
            line: 109,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 109,
            column: 21
          },
          end: {
            line: 109,
            column: 37
          }
        }, {
          start: {
            line: 109,
            column: 41
          },
          end: {
            line: 109,
            column: 43
          }
        }],
        line: 109
      },
      "4": {
        loc: {
          start: {
            line: 110,
            column: 2
          },
          end: {
            line: 123,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 110,
            column: 2
          },
          end: {
            line: 123,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 110
      },
      "5": {
        loc: {
          start: {
            line: 111,
            column: 22
          },
          end: {
            line: 120,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 112,
            column: 8
          },
          end: {
            line: 119,
            column: 9
          }
        }, {
          start: {
            line: 120,
            column: 8
          },
          end: {
            line: 120,
            column: 92
          }
        }],
        line: 111
      },
      "6": {
        loc: {
          start: {
            line: 139,
            column: 16
          },
          end: {
            line: 139,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 139,
            column: 17
          },
          end: {
            line: 139,
            column: 28
          }
        }, {
          start: {
            line: 139,
            column: 32
          },
          end: {
            line: 139,
            column: 49
          }
        }, {
          start: {
            line: 139,
            column: 55
          },
          end: {
            line: 139,
            column: 62
          }
        }, {
          start: {
            line: 139,
            column: 66
          },
          end: {
            line: 139,
            column: 79
          }
        }],
        line: 139
      },
      "7": {
        loc: {
          start: {
            line: 140,
            column: 22
          },
          end: {
            line: 140,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 140,
            column: 22
          },
          end: {
            line: 140,
            column: 27
          }
        }, {
          start: {
            line: 140,
            column: 31
          },
          end: {
            line: 140,
            column: 43
          }
        }],
        line: 140
      },
      "8": {
        loc: {
          start: {
            line: 142,
            column: 4
          },
          end: {
            line: 142,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 142,
            column: 5
          },
          end: {
            line: 142,
            column: 10
          }
        }, {
          start: {
            line: 142,
            column: 15
          },
          end: {
            line: 142,
            column: 85
          }
        }, {
          start: {
            line: 142,
            column: 91
          },
          end: {
            line: 142,
            column: 93
          }
        }],
        line: 142
      },
      "9": {
        loc: {
          start: {
            line: 142,
            column: 15
          },
          end: {
            line: 142,
            column: 85
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 142,
            column: 60
          },
          end: {
            line: 142,
            column: 71
          }
        }, {
          start: {
            line: 142,
            column: 74
          },
          end: {
            line: 142,
            column: 85
          }
        }],
        line: 142
      },
      "10": {
        loc: {
          start: {
            line: 142,
            column: 15
          },
          end: {
            line: 142,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 142,
            column: 15
          },
          end: {
            line: 142,
            column: 26
          }
        }, {
          start: {
            line: 142,
            column: 30
          },
          end: {
            line: 142,
            column: 57
          }
        }],
        line: 142
      },
      "11": {
        loc: {
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 161,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 161,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 145
      },
      "12": {
        loc: {
          start: {
            line: 145,
            column: 8
          },
          end: {
            line: 145,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 145,
            column: 8
          },
          end: {
            line: 145,
            column: 27
          }
        }, {
          start: {
            line: 145,
            column: 31
          },
          end: {
            line: 145,
            column: 80
          }
        }, {
          start: {
            line: 145,
            column: 84
          },
          end: {
            line: 145,
            column: 97
          }
        }],
        line: 145
      },
      "13": {
        loc: {
          start: {
            line: 148,
            column: 6
          },
          end: {
            line: 155,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 148,
            column: 6
          },
          end: {
            line: 155,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 148
      },
      "14": {
        loc: {
          start: {
            line: 169,
            column: 21
          },
          end: {
            line: 169,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 169,
            column: 22
          },
          end: {
            line: 169,
            column: 27
          }
        }, {
          start: {
            line: 169,
            column: 31
          },
          end: {
            line: 169,
            column: 42
          }
        }, {
          start: {
            line: 169,
            column: 46
          },
          end: {
            line: 169,
            column: 91
          }
        }, {
          start: {
            line: 169,
            column: 96
          },
          end: {
            line: 169,
            column: 98
          }
        }],
        line: 169
      },
      "15": {
        loc: {
          start: {
            line: 172,
            column: 29
          },
          end: {
            line: 172,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 172,
            column: 29
          },
          end: {
            line: 172,
            column: 40
          }
        }, {
          start: {
            line: 172,
            column: 44
          },
          end: {
            line: 172,
            column: 51
          }
        }],
        line: 172
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0, 0, 0],
      "7": [0, 0],
      "8": [0, 0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0, 0, 0, 0],
      "15": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a497a2689429322935202704eeab8f04d666610c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2i4ocq7usk = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2i4ocq7usk();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var ASPECT_RATIOS = (cov_2i4ocq7usk().s[0]++, {
  VERTICAL: 2 / 3,
  HORIZONTAL: 4 / 3,
  WIDE: 16 / 10,
  SQUARE: 1 / 1,
  LANDSCAPE: 2.5 / 1
});
var Wrapper = (cov_2i4ocq7usk().s[1]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: function className(props) {
    cov_2i4ocq7usk().f[0]++;
    cov_2i4ocq7usk().s[2]++;
    return "stx-ProductImage stx-ProductImage-".concat(props.productId);
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      display: block;\n      position: relative;\n      overflow: hidden;\n      vertical-align: top;\n      background-color: #ebeff4;\n      margin: 0;\n      padding: 0;\n\n      > img {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n\n        will-change: filter;\n        transition: filter 0.25s;\n      }\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      display: block;\n      position: relative;\n      overflow: hidden;\n      background-color: inherit;\n      margin: 0;\n      padding: 0;\n\n      border-radius: var(--generalBorderRadius, 12px);\n\n      > img {\n        object-fit: contain;\n      }\n\n      > img {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n\n        will-change: filter;\n        transition: filter 0.25s;\n      }\n    "]))))));
var pushedProducts = (cov_2i4ocq7usk().s[3]++, []);
cov_2i4ocq7usk().s[4]++;
var pushProductDataLayer = function pushProductDataLayer(data, user, useGA4) {
  cov_2i4ocq7usk().f[1]++;
  cov_2i4ocq7usk().s[5]++;
  window.dataLayer = (cov_2i4ocq7usk().b[0][0]++, window.dataLayer) || (cov_2i4ocq7usk().b[0][1]++, []);
  cov_2i4ocq7usk().s[6]++;
  if (data) {
    cov_2i4ocq7usk().b[1][0]++;
    var dataLayer = (cov_2i4ocq7usk().s[7]++, useGA4 ? (cov_2i4ocq7usk().b[2][0]++, {
      event: 'view_item_list',
      ecommerce: {
        items: [_objectSpread({}, (0, _utils.convertToGA4Attribute)(_utils.GA4EventEnum.productImpression, data))]
      }
    }) : (cov_2i4ocq7usk().b[2][1]++, {
      event: 'ee-productImpression',
      ecommerce: {
        impressions: [_objectSpread({}, data)]
      }
    }));
    cov_2i4ocq7usk().s[8]++;
    window.dataLayer.push(_ProductHelper.default.addUserInfo(dataLayer, user));
  } else {
    cov_2i4ocq7usk().b[1][1]++;
  }
};
cov_2i4ocq7usk().s[9]++;
var pushAdvantageDataLayer = function pushAdvantageDataLayer(data, user, useGA4) {
  cov_2i4ocq7usk().f[2]++;
  cov_2i4ocq7usk().s[10]++;
  window.dataLayer = (cov_2i4ocq7usk().b[3][0]++, window.dataLayer) || (cov_2i4ocq7usk().b[3][1]++, []);
  cov_2i4ocq7usk().s[11]++;
  if (data) {
    cov_2i4ocq7usk().b[4][0]++;
    var dataLayer = (cov_2i4ocq7usk().s[12]++, useGA4 ? (cov_2i4ocq7usk().b[5][0]++, {
      event: 'view_promotion',
      ecommerce: {
        items: data.map(function (d) {
          cov_2i4ocq7usk().f[3]++;
          cov_2i4ocq7usk().s[13]++;
          return _objectSpread({}, (0, _utils.convertToGA4Attribute)(_utils.GA4EventEnum.promoImpression, d));
        })
      }
    }) : (cov_2i4ocq7usk().b[5][1]++, {
      event: 'ee-promoImpression',
      ecommerce: {
        promoView: {
          promotions: (0, _toConsumableArray2.default)(data)
        }
      }
    }));
    cov_2i4ocq7usk().s[14]++;
    window.dataLayer.push(_ProductHelper.default.addUserInfo(dataLayer, user));
  } else {
    cov_2i4ocq7usk().b[4][1]++;
  }
};

/*
 * Component to display the image of a product
 */
function ProductImage(_ref) {
  var product = _ref.product,
    performance = _ref.performance,
    aspectRatio = _ref.aspectRatio,
    tooltip = _ref.tooltip,
    isLandingPage = _ref.isLandingPage,
    ecommerceGoogleTracking = _ref.ecommerceGoogleTracking,
    alt = _ref.alt,
    resizeMode = _ref.resizeMode;
  cov_2i4ocq7usk().f[4]++;
  var image = (cov_2i4ocq7usk().s[15]++, (cov_2i4ocq7usk().b[6][0]++, performance) && (cov_2i4ocq7usk().b[6][1]++, performance.image) || (cov_2i4ocq7usk().b[6][2]++, product) && (cov_2i4ocq7usk().b[6][3]++, product.image));
  var imageXlarge = (cov_2i4ocq7usk().s[16]++, (cov_2i4ocq7usk().b[7][0]++, image) && (cov_2i4ocq7usk().b[7][1]++, image.xlarge));
  var imageSrc = (cov_2i4ocq7usk().s[17]++, (cov_2i4ocq7usk().b[8][0]++, image) && (cov_2i4ocq7usk().b[8][1]++, (cov_2i4ocq7usk().b[10][0]++, imageXlarge) && (cov_2i4ocq7usk().b[10][1]++, aspectRatio === 'LANDSCAPE') ? (cov_2i4ocq7usk().b[9][0]++, imageXlarge) : (cov_2i4ocq7usk().b[9][1]++, image.large)) || (cov_2i4ocq7usk().b[8][2]++, ''));
  cov_2i4ocq7usk().s[18]++;
  var onEnterViewPort = function onEnterViewPort(productForDataLayer) {
    cov_2i4ocq7usk().f[5]++;
    cov_2i4ocq7usk().s[19]++;
    if ((cov_2i4ocq7usk().b[12][0]++, productForDataLayer) && (cov_2i4ocq7usk().b[12][1]++, ecommerceGoogleTracking.useGoogleEnhancedTracking) && (cov_2i4ocq7usk().b[12][2]++, isLandingPage)) {
      cov_2i4ocq7usk().b[11][0]++;
      var productDataLayer = (cov_2i4ocq7usk().s[20]++, productForDataLayer.productDataLayer);
      var advantageDataLayer = (cov_2i4ocq7usk().s[21]++, productForDataLayer.advantageDataLayer);
      cov_2i4ocq7usk().s[22]++;
      if (!pushedProducts.includes(productDataLayer)) {
        cov_2i4ocq7usk().b[13][0]++;
        cov_2i4ocq7usk().s[23]++;
        pushedProducts.push(productDataLayer);
        cov_2i4ocq7usk().s[24]++;
        pushProductDataLayer(productDataLayer, ecommerceGoogleTracking.user, ecommerceGoogleTracking.useGA4);
      } else {
        cov_2i4ocq7usk().b[13][1]++;
      }
      cov_2i4ocq7usk().s[25]++;
      pushAdvantageDataLayer(advantageDataLayer, ecommerceGoogleTracking.user, ecommerceGoogleTracking.useGA4);
    } else {
      cov_2i4ocq7usk().b[11][1]++;
    }
  };
  cov_2i4ocq7usk().s[26]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    productId: product.id,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 165,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_image.default, {
    alt: alt,
    title: tooltip,
    placeholder: (cov_2i4ocq7usk().b[14][0]++, image) && (cov_2i4ocq7usk().b[14][1]++, image.small) && (cov_2i4ocq7usk().b[14][2]++, image.small.replace('/small/', '/thumbnail/')) || (cov_2i4ocq7usk().b[14][3]++, ''),
    src: imageSrc,
    aspectRatio: ASPECT_RATIOS[aspectRatio],
    productForDataLayer: (cov_2i4ocq7usk().b[15][0]++, performance) || (cov_2i4ocq7usk().b[15][1]++, product),
    onEnterViewPort: onEnterViewPort,
    resizeMode: resizeMode,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 166,
      columnNumber: 7
    }
  }));
}
cov_2i4ocq7usk().s[27]++;
ProductImage.propTypes = {
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* A specific performance to display, if provided take the performance data in priority */
  performance: _product.PerformanceType,
  /** The display ratio of the picture : TODO : inform what aspect ratio correspond to which value */
  aspectRatio: _propTypes.default.oneOf(['VERTICAL', 'HORIZONTAL', 'WIDE', 'SQUARE', 'LANDSCAPE']),
  /** The content is displayed when hovering mouse on image */
  tooltip: _propTypes.default.string,
  /** Type definitions for react-intl, using for dynamic message */
  intl: _reactIntl.intlShape.isRequired,
  /** Option to use google enhance tracking to push data to data layer */
  ecommerceGoogleTracking: _propTypes.default.shape({}),
  /** Indicator of current page is landing page */
  isLandingPage: _propTypes.default.bool,
  /** Alt content of icon - Use for accessibility */
  alt: _propTypes.default.string,
  resizeMode: _propTypes.default.string,
  themeContext: _themeProvider.ThemeContextType,
  themeQueries: _utils.WithThemeQueriesType
};
cov_2i4ocq7usk().s[28]++;
ProductImage.defaultProps = {
  aspectRatio: 'SQUARE',
  tooltip: '',
  performance: null,
  isLandingPage: false,
  ecommerceGoogleTracking: {
    useGoogleEnhancedTracking: false,
    user: {},
    useGA4: false
  },
  alt: '',
  resizeMode: 'cover',
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  themeQueries: {}
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)((0, _reactIntl.injectIntl)(ProductImage)));